var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5001 6H3.5",
    stroke: "#9090AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8346 8.5L18.3747 15.3991C18.1977 18.054 18.1092 19.3815 17.2442 20.1907C16.3792 21 15.0488 21 12.388 21H11.6146C8.95382 21 7.62342 21 6.75841 20.1907C5.8934 19.3815 5.8049 18.054 5.62791 15.3991L5.16797 8.5",
    stroke: "#9090AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2463 10.9254C10.2051 10.5132 9.83753 10.2125 9.42537 10.2537C9.01321 10.2949 8.71251 10.6625 8.75372 11.0746L9.5 11L10.2463 10.9254ZM9.25372 16.0746C9.29494 16.4868 9.66247 16.7875 10.0746 16.7463C10.4868 16.7051 10.7875 16.3375 10.7463 15.9254L10 16L9.25372 16.0746ZM9.5 11L8.75372 11.0746L9.25372 16.0746L10 16L10.7463 15.9254L10.2463 10.9254L9.5 11Z",
    fill: "#9090AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2463 11.0746C15.2875 10.6625 14.9868 10.2949 14.5746 10.2537C14.1625 10.2125 13.7949 10.5132 13.7537 10.9254L14.5 11L15.2463 11.0746ZM13.2537 15.9254C13.2125 16.3375 13.5132 16.7051 13.9254 16.7463C14.3375 16.7875 14.7051 16.4868 14.7463 16.0746L14 16L13.2537 15.9254ZM14.5 11L13.7537 10.9254L13.2537 15.9254L14 16L14.7463 16.0746L15.2463 11.0746L14.5 11Z",
    fill: "#9090AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6",
    stroke: "#9090AB",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline);
export default __webpack_public_path__ + "static/media/Trash_Outline.f2bf248e61789431e204bf93656178c8.svg";
export { ForwardRef as ReactComponent };